/**
 * Head selection utilities.
 *
 * The server decides each target's default branch (target_default_branch:
 * the repository's default branch as reported by CI, then main, then master,
 * then the most recently updated branch) and marks that head with
 * `is_default`. Clients use the flag and never derive a default of their own.
 */

/**
 * The head a target opens on: the head the server marked as default, else the
 * first head (a target with no branch heads at all, e.g. only PR builds).
 *
 * @param {Array<Object>|null} heads - Head records from the heads endpoint
 * @returns {Object|null} The default head, or null when there are no heads
 */
export const findDefaultHead = (heads) => {
  if (!heads || heads.length === 0) return null;
  return heads.find(h => h.is_default) || heads[0];
};
